export default "__VITE_ASSET__C5m7d6n8__";